export default __webpack_public_path__ + "static/quote2-b2b750c2ce45ad0511003e80c5b0ea8e.svg";